
        import 'InfoPanel.63ee9a0.css-module'
        export default {"infoPanel":"infoPanel_InfoPanel_63ee9a0"}
    